module.exports = __webpack_public_path__ + "img/male_age.6c14cbfc.png";